import React, { useEffect, useRef } from 'react'

import { WaitingForInstantDataContent } from '@frame/ui-components/waiting-for-instant-data-content'
import { WidgetHeaderWithNavigation } from '@frame/ui-components/widget-header'
import { Body } from '@frame/ui-primitives/body'

import { useRootContext } from '@frame/lib/context'
import { DataAttribute } from '@frame/types'

const MIN_WAIT_TIME = 2000
const POLL_INTERVAL = 1000

export function WaitingForInstantData() {
  const { actions } = useRootContext()
  const intervalRef = useRef<NodeJS.Timeout>()

  useEffect(() => {
    const refreshSession = async () => {
      await actions.getSession()
    }

    setTimeout(() => {
      refreshSession()
      intervalRef.current = setInterval(refreshSession, POLL_INTERVAL)
    }, MIN_WAIT_TIME)

    return () => {
      clearInterval(intervalRef.current)
    }
  }, [actions])

  return (
    <>
      <WidgetHeaderWithNavigation showCobranding backButton={{ visible: false }} />
      <Body data-cy={DataAttribute.SCREEN_WAITING_FOR_INSTANT_DATA} className="h-full p-5">
        <WaitingForInstantDataContent />
      </Body>
    </>
  )
}
